import {
  MAX_COMPARE_FILTER_BARS,
} from '@utils/constants';
import { getFilterFromRules } from '@utils';

/* eslint-disable import/prefer-default-export */
export const validateNewFilterBar = (filterBars, savedFilterBars) => {
  const mergedFilterBars = [...filterBars, ...savedFilterBars];
  // Check filter limit
  if (mergedFilterBars.length > MAX_COMPARE_FILTER_BARS) {
    return {
      status: false,
      msg: `Cannot create more than ${MAX_COMPARE_FILTER_BARS} filters`,
    };
  }
  // Check for duplicate rules
  const rulesSet = new Set();
  mergedFilterBars.forEach((filterBar) => {
    const filterId = filterBar.name ? filterBar.name : getFilterFromRules(filterBar.filters).name;
    rulesSet.add(filterId);
  });

  if (rulesSet.size !== mergedFilterBars.length) {
    return {
      status: false,
      msg: 'Filter already exists',
    };
  }
  return {
    status: true,
  };
};
